module.exports = __webpack_public_path__ + "public/img/orderserver.28102f9f.jpg";